import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { defaultProjectThumbnail } from "@utils/project-utils";
import { ChangeThumbnailDialog } from "@pages/project-details/project-overview/project-thumbnail/change-thumbnail-dialog";

/** Width of the default thumbnail image */
const DEFAULT_THUMBNAIL_IMAGE_WIDTH = 250;

/** Height of default thumbnail image */
const DEFAULT_THUMBNAIL_IMAGE_HEIGHT = 150;

/** Aspect ratio of the default thumbnail image */
const DEFAULT_THUMBNAIL_ASPECT_RATIO = DEFAULT_THUMBNAIL_IMAGE_WIDTH / DEFAULT_THUMBNAIL_IMAGE_HEIGHT;
/**
 * Shows the thumbnail image of the project.
 * If the project is still loading, a skeleton will be shown instead.
 */
export function ProjectThumbnailImage(t0) {
  const $ = _c(9);
  const {
    project,
    isLoading,
    isProjectEditable
  } = t0;
  if (isLoading || !project) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton variant="rectangular" sx={{
        width: "100%",
        height: "auto",
        aspectRatio: DEFAULT_THUMBNAIL_ASPECT_RATIO
      }} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = project.thumbnailUrl ?? undefined;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      height: "auto",
      aspectRatio: DEFAULT_THUMBNAIL_ASPECT_RATIO,
      objectFit: "contain"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== project.thumbnailUrl) {
    t3 = <ThumbnailImage src={project.thumbnailUrl} fallbackSrc={defaultProjectThumbnail} alt="Project thumbnail" sx={t2} />;
    $[2] = project.thumbnailUrl;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isProjectEditable || $[5] !== project.id || $[6] !== t1 || $[7] !== t3) {
    t4 = <ChangeThumbnailDialog existingThumbnailUrl={t1} isAllowedToChange={isProjectEditable} projectId={project.id}>{t3}</ChangeThumbnailDialog>;
    $[4] = isProjectEditable;
    $[5] = project.id;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}